export interface Vec2 {
  x: number
  y: number
}

export const enum DietType {
  Herbivore = 'herbivore',
  Carnivore = 'carnivore',
  Omnivore = 'omnivore',
}

/** 生物の個性パラメーター（遺伝形質） */
export interface Traits {
  /** 移動速度 (px/frame) */
  speed: number
  /** 視野半径 (px) */
  visionRange: number
  /** 体のサイズ (半径 px) */
  size: number
  /** 食性 */
  diet: DietType
  /** HSL の色相 (0-360) */
  hue: number
  /** エネルギー消費率の乗数 */
  metabolismRate: number
  /** 繁殖力: 高いほど低いエネルギーで繁殖できる (0.5〜1.5) */
  fertilityRate: number
}

/** 障害物（円形） */
export interface Obstacle {
  pos: Vec2
  radius: number
}

/** 個体数の時系列スナップショット */
export interface PopSnapshot {
  tick: number
  herbivores: number
  carnivores: number
  omnivores: number
}

/** 初期個体数の設定 */
export interface PopulationConfig {
  herbivores: number
  carnivores: number
  omnivores: number
}
